import { createContext, use } from 'react';

import { noop } from '@/_shared';

import type { PermissionsType, UseAuthValues } from './use-auth-values';

export const AuthContext = createContext<UseAuthValues>({
  user: null,
  setUser: noop,
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  getPermissibleTabs: noop,
  permissions: {} as PermissionsType,
});

export const useAuthContext = () => use(AuthContext);
